import React from "react";
import { useEntitlements } from "../../hooks/useEntitlements";
import { TFeatureKey } from "../../services/types/users.types";
import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./FeatureUsageCounter.module.css";

interface FeatureUsageCounterProps {
  featureKey: TFeatureKey;
}

const FeatureUsageCounter: React.FC<FeatureUsageCounterProps> = ({ featureKey }) => {
  const { getFeatureUsage } = useEntitlements();
  const usage = getFeatureUsage(featureKey);

  if (!usage) return null;

  // Prefer the more restrictive (non-null) limit: user-level first, then company
  const limit = usage.userLimit ?? usage.companyLimit;
  const used = usage.userLimit !== null ? usage.userUsed : usage.companyUsed;

  // Purchased count-credits, consulted after the monthly count runs out.
  const purchased =
    usage.userLimit !== null
      ? usage.userWalletBalance
      : usage.companyWalletBalance;

  if (limit === null) return null;

  return (
    <div className={styles.wrapper}>
      <span className={styles.counter}>
        {t("TRIAL_FEATURE_USAGE", { used, limit })}
      </span>
      {purchased > 0 && (
        <span className={styles.purchased}>
          {t("FEATURE_PURCHASED_CREDITS", { amount: purchased })}
        </span>
      )}
      {usage.trialReduced && (
        <span className={styles.trialBadge}>
          {t("TRIAL_LIMIT")}
        </span>
      )}
    </div>
  );
};

export default FeatureUsageCounter;
